import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalFooter, FormGroup, Input } from "reactstrap";
import { toast } from "react-toastify";
import "./pos-modal.css";

const emptyForm = {
  zipcode: "",
  street: "",
  street_number: "",
  complementary: "",
  neighborhood: "",
  city: "",
  state: "",
};

export default function AddressModal({ isOpen, onClose, onSave, initialAddress }) {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (isOpen) {
      setForm(initialAddress ? { ...emptyForm, ...initialAddress } : emptyForm);
    }
  }, [isOpen]);

  const set = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const fetchCep = async (cep) => {
    if (cep.length !== 8) return;
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await res.json();
      if (data.erro) return;
      setForm((f) => ({
        ...f,
        street: data.logradouro || "",
        neighborhood: data.bairro || "",
        city: data.localidade || "",
        state: data.uf || "",
      }));
    } catch {}
  };

  const handleSave = () => {
    onSave({ ...form });
    toast.success("Endereço salvo!");
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="md" className="pos-modal">
      <div className="modal-header">
        <span className="modal-title">Endereço de entrega</span>
        <button className="pos-modal-close-btn" onClick={handleClose}>×</button>
      </div>

      <ModalBody>
        <FormGroup className="mb-3">
          <label className="pos-modal-label">CEP</label>
          <Input
            type="text"
            placeholder="00000-000"
            value={form.zipcode}
            maxLength={9}
            className="pos-modal-input"
            onChange={(e) => {
              const v = e.target.value.replace(/\D/g, "").slice(0, 8);
              const masked =
                v.length > 5 ? `${v.slice(0, 5)}-${v.slice(5)}` : v;
              set("zipcode", masked);
              fetchCep(v);
            }}
          />
        </FormGroup>

        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 80px", gap: 8 }}
        >
          <FormGroup className="mb-3">
            <label className="pos-modal-label">Rua / Logradouro</label>
            <Input
              type="text"
              placeholder="Nome da rua"
              value={form.street}
              onChange={(e) => set("street", e.target.value)}
              className="pos-modal-input"
            />
          </FormGroup>
          <FormGroup className="mb-3">
            <label className="pos-modal-label">Número</label>
            <Input
              type="text"
              placeholder="Nº"
              value={form.street_number}
              onChange={(e) => set("street_number", e.target.value)}
              className="pos-modal-input"
            />
          </FormGroup>
        </div>

        <FormGroup className="mb-3">
          <label className="pos-modal-label">Complemento</label>
          <Input
            type="text"
            placeholder="Apto, Bloco... (opcional)"
            value={form.complementary}
            onChange={(e) => set("complementary", e.target.value)}
            className="pos-modal-input"
          />
        </FormGroup>

        <FormGroup className="mb-3">
          <label className="pos-modal-label">Bairro</label>
          <Input
            type="text"
            placeholder="Bairro"
            value={form.neighborhood}
            onChange={(e) => set("neighborhood", e.target.value)}
            className="pos-modal-input"
          />
        </FormGroup>

        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 70px", gap: 8 }}
        >
          <FormGroup className="mb-0">
            <label className="pos-modal-label">Cidade</label>
            <Input
              type="text"
              placeholder="Cidade"
              value={form.city}
              onChange={(e) => set("city", e.target.value)}
              className="pos-modal-input"
            />
          </FormGroup>
          <FormGroup className="mb-0">
            <label className="pos-modal-label">UF</label>
            <Input
              type="text"
              placeholder="MG"
              maxLength={2}
              value={form.state}
              onChange={(e) => set("state", e.target.value.toUpperCase())}
              className="pos-modal-input"
            />
          </FormGroup>
        </div>
      </ModalBody>

      <ModalFooter>
        <button
          className="pos-modal-btn pos-modal-btn--primary"
          onClick={handleSave}
        >
          Salvar endereço
        </button>
        <button
          className="pos-modal-btn pos-modal-btn--secondary"
          onClick={handleClose}
        >
          Cancelar
        </button>
      </ModalFooter>
    </Modal>
  );
}
